
    module.exports = {
        getAreaStyle: require('./makeStyleMapper')(
            [
                ['fill', 'color'],
                ['shadowBlur'],
                ['shadowOffsetX'],
                ['shadowOffsetY'],
                ['opacity'],
                ['shadowColor']
            ]
        )
    };



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/model/mixin/areaStyle.js
// module id = 541
// module chunks = 1